/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIMessageAutocompleteSuggestion
 */
export interface APIMessageAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIMessageAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIMessageAutocompleteSuggestion
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof APIMessageAutocompleteSuggestion
     */
    channelName: string;
    /**
     * 
     * @type {string}
     * @memberof APIMessageAutocompleteSuggestion
     */
    authorFullName: string;
    /**
     * 
     * @type {string}
     * @memberof APIMessageAutocompleteSuggestion
     */
    authorEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof APIMessageAutocompleteSuggestion
     */
    createdAt?: Date | null;
}

/**
 * Check if a given object implements the APIMessageAutocompleteSuggestion interface.
 */
export function instanceOfAPIMessageAutocompleteSuggestion(value: object): value is APIMessageAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('channelName' in value) || value['channelName'] === undefined) return false;
    if (!('authorFullName' in value) || value['authorFullName'] === undefined) return false;
    if (!('authorEmail' in value) || value['authorEmail'] === undefined) return false;
    return true;
}

export function APIMessageAutocompleteSuggestionFromJSON(json: any): APIMessageAutocompleteSuggestion {
    return APIMessageAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIMessageAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMessageAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'body': json['body'],
        'channelName': json['channel_name'],
        'authorFullName': json['author_full_name'],
        'authorEmail': json['author_email'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function APIMessageAutocompleteSuggestionToJSON(value?: APIMessageAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'body': value['body'],
        'channel_name': value['channelName'],
        'author_full_name': value['authorFullName'],
        'author_email': value['authorEmail'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
    };
}

